import {useEffect, useState} from 'react';
import {
  getAreWeGettingCloseToMobile,
  getAreWeRunningInMobile,
} from '../utils/functions/get-are-we-running-in-mobile';

export function useObserveViewport() {
  const [isRunningMobile, setIsRunningMobile] = useState<boolean>(getAreWeRunningInMobile());
  const [isRunningCloseToMobile, setIsRunningCloseToMobile] = useState<boolean>(
    getAreWeGettingCloseToMobile()
  );

  useEffect(() => {
    const onWindowResize = () => {
      setIsRunningMobile(getAreWeRunningInMobile());
      setIsRunningCloseToMobile(getAreWeGettingCloseToMobile());
    };

    window.addEventListener('resize', onWindowResize);

    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, []);

  return {
    isRunningMobile,
    isRunningCloseToMobile,
  };
}
